const aboutUsData = {
  brand: "عنا",
  list: [
    {
      id: 1,
      title: "من نحن",
      text: [
        "برنامج وذكر: برنامج للأذكار والأدعية, يشتمل علي عدد كبير من الأذكار والأدعية التي نحتاجها في حياتنا اليومية وبصفة دائمة.",
      ],
    },
    {
      id: 2,
      title: "الغرض من التطبيق",
      text: [
        "لا يوجد نية حاليا لنشر التطبيق للإستخدام من قبل العامة، ربما يوما ما، وإنما تم تنفيذ هذا التطبيق للتدرب علي بعض كورسات الويب وليضاف لقائمة الأعمال الخاصة بي.",
      ],
    },
    {
      id: 3,
      title: "من أنا",
      text: [
        `أخيكم ف الله : أحمد عبدالرحيم شخص أحب التصميم والبرمجة تعلم ذاتيا عن طريق الإنترنت, وأعمل حاليا كمطور وأجهات ومصمم ويب`,
      ],
    },
  ],
};

export default aboutUsData;
